import axios from 'axios'

const api = axios.create({
  // baseURL: 'http://192.1.0.40:2020/webrunstudio/' // local
  // baseURL: 'https://api.aspprev.tec.br/'
  baseURL: 'https://asphmg.cibriusonline.com/'
})

export default api
